export default __webpack_public_path__ + "static/media/sangeeta.acee4898.png";